const HOT = {
    COMMON:"common/recentNews/list",//獲取熱詞列表
}
export default HOT